<template>
  <RedirectPage />
</template>

<script>
import RedirectPage from "./components/RedirectPage.vue";

export default {
  components: {
    RedirectPage,
  },
};
</script>


<style>
/* Apply dark theme globally */
html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
  background-color: #f3f6f8;
  /* Dark background */
  color: #e1e1e1;
  /* Light text color */
}
</style>